export const cleanupStep2 = (data) => {
  const cleanedData = { ...data };
  
  // Функция для нормализации ФИО
  const normalizeName = (name) => {
    if (!name) return '';
    
    return name
      .replace(/\s+/g, ' ')
      .trim()
      .split(/[\s-]+/)
      .map(word => {
        // Обработка составных фамилий и имен
        if (word.includes('-')) {
          return word
            .split('-')
            .map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
            .join('-');
        }
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(' ');
  };

  // Нормализация ФИО
  cleanedData.applicant.lastName = normalizeName(cleanedData.applicant.lastName);
  cleanedData.applicant.firstName = normalizeName(cleanedData.applicant.firstName);
  cleanedData.applicant.middleName = normalizeName(cleanedData.applicant.middleName);

  // Логика для РНОКПП и документов (как в основной версии)
  if (cleanedData.applicant.hasRnokpp === 'yes') {
    cleanedData.applicant.documentType = '';
    cleanedData.applicant.documentDetails = '';
    
    if (cleanedData.applicant.rnokpp) {
      cleanedData.applicant.rnokpp = cleanedData.applicant.rnokpp.replace(/\D/g, '');
    }
  } else if (cleanedData.applicant.hasRnokpp === 'no') {
    cleanedData.applicant.rnokpp = '';
    
    // Дополнительная валидация документов
    if (cleanedData.applicant.documentType === 'passport' && cleanedData.applicant.documentDetails) {
      const docValue = cleanedData.applicant.documentDetails.toUpperCase().replace(/\s/g, '');
      const letters = docValue.replace(/[^A-ZА-ЯІЇЄ]/g, '');
      const digits = docValue.replace(/[^0-9]/g, '');
      
      // Проверяем формат: 2 буквы + 6 цифр
      if (letters.length !== 2 || digits.length !== 6) {
        // Если формат неправильный, очищаем
        cleanedData.applicant.documentDetails = '';
      }
    } else if (cleanedData.applicant.documentType === 'idCard' && cleanedData.applicant.documentDetails) {
      const digits = cleanedData.applicant.documentDetails.replace(/\D/g, '');
      
      // Проверяем формат: 9 цифр
      if (digits.length !== 9) {
        cleanedData.applicant.documentDetails = '';
      }
    }
  }

  // Нормализация телефона с проверкой кода страны
  if (false && cleanedData.applicant.phone) {
    let phone = cleanedData.applicant.phone.trim();
    const hasPlus = phone.startsWith('+');
    
    if (!hasPlus && phone) {
      // Если нет +, добавляем код Украины по умолчанию
      if (phone.startsWith('0')) {
        phone = '+38' + phone;
      } else {
        phone = '+' + phone;
      }
    }
    
    // Оставляем только цифры и +
    phone = phone.replace(/[^\d+]/g, '');
    
    // Убеждаемся, что после + идут цифры
    if (phone.startsWith('+') && phone.length > 1 && !/^\+\d+$/.test(phone)) {
      phone = '';
    }
    
    cleanedData.applicant.phone = phone;
  }

  // Более строгая валидация email
  if (cleanedData.applicant.email) {
    let email = cleanedData.applicant.email.trim().toLowerCase();
    
    // Убираем все пробелы
    email = email.replace(/\s/g, '');
    
    // Проверяем базовый формат
    const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    
    if (!emailRegex.test(email)) {
      cleanedData.applicant.email = '';
    } else {
      cleanedData.applicant.email = email;
    }
  }

  // Дополнительная логика для иностранных граждан
  if (cleanedData.applicant.citizenship === 'Інше') {
    // Для иностранцев принудительно устанавливаем отсутствие РНОКПП
    cleanedData.applicant.hasRnokpp = 'no';
    cleanedData.applicant.rnokpp = '';
    
    // Можно добавить специальные типы документов для иностранцев
    if (!['passport', 'idCard'].includes(cleanedData.applicant.documentType)) {
      cleanedData.applicant.documentType = 'passport'; // или другой документ по умолчанию
    }
  }

  return cleanedData;
};